import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "icon", "iconPosition", "counter", "counterMaxLength", "scrollInView"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../../../ControlInputContainer';
import { getCounterValue } from './utils';
import { useForkRef } from '@cian/react-utils';
import * as styles from './ChipButton.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент чипса
 *
 * @export
 * @param {IChipButtonProps} props
 * @returns
 */
export var ChipButton = /*#__PURE__*/React.forwardRef(function ControlButton(props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'M' : _props$size,
    icon = props.icon,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'right' : _props$iconPosition,
    counter = props.counter,
    counterMaxLength = props.counterMaxLength,
    scrollInView = props.scrollInView,
    controlProps = _objectWithoutProperties(props, _excluded);
  var onChange = controlProps.onChange,
    checked = controlProps.checked,
    invalid = controlProps.invalid,
    label = controlProps.label;
  var counterValue = React.useMemo(function () {
    return typeof counter !== 'undefined' ? getCounterValue(counter, counterMaxLength) : undefined;
  }, [counter, counterMaxLength]);
  var localInputRef = React.useRef(null);
  var inputRef = useForkRef(props.inputRef, localInputRef);
  var handleChange = function handleChange(event, value) {
    if (onChange) {
      onChange(event, value);
    }
    if (!value) {
      var _localInputRef$curren;
      (_localInputRef$curren = localInputRef.current) === null || _localInputRef$curren === void 0 || _localInputRef$curren.blur();
    }
  };
  var handleClick = function handleClick(event) {
    if (!scrollInView) {
      return;
    }
    event.currentTarget.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  };
  var disabled = props.disabled || counter === 0;
  return /*#__PURE__*/_jsx(ControlInputContainer, _objectSpread(_objectSpread({}, controlProps), {}, {
    disabled: disabled,
    onClick: handleClick,
    onChange: handleChange,
    className: clsx(styles['chip-button'], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['chip-button--checked'], checked), styles['chip-button--disabled'], disabled), styles['chip-button--invalid'], invalid), styles['chip-button--only-icon'], !label && icon), styles['chip-button--small'], size === 'XS'), styles['chip-button--medium'], size === 'M')),
    ref: ref,
    inputRef: inputRef,
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx(styles['button']),
      role: "button",
      children: [label && /*#__PURE__*/_jsx("span", {
        className: styles['label'],
        children: label
      }), icon && !counter && /*#__PURE__*/_jsx("span", {
        className: clsx(styles['icon'], _defineProperty({}, styles['icon--left'], iconPosition === 'left')),
        children: icon
      }), counterValue && /*#__PURE__*/_jsx("span", {
        className: styles['counter'],
        children: counterValue
      })]
    })
  }));
});